import { UrlBasePathService } from '../../utils/UrlBasePathUtil';
import { IndexedDBKeyValueStorage } from '@formbird/indexed-db';

const logger = console;

export class KeyValueStorageService extends IndexedDBKeyValueStorage{
  private urlBasePathService: UrlBasePathService;

  constructor() {
    super();
    this.urlBasePathService = new UrlBasePathService();
  }

  public setItem(key, value) {
    key = this.urlBasePathService.getBasePath() + key;
    const self = this;
  

    return new Promise<any>((resolve, reject) => {

      super.setItem(key, value).then(result => {
        resolve(result);
      }, e => {
        if (e.name === 'OpenFailedError') {
          logger.error('Error getting dexie entries, open failed error.');
          resolve(value);
        } else {
          reject(e);
        }
      });
    });
  }

  public getItem(key) {
    key = this.urlBasePathService.getBasePath() + key;
    const self = this; 

    return new Promise<any>((resolve, reject) => {
      super.getItem(key).then(result => {
        resolve(result);
      }, error => {
         if (error.name === 'OpenFailedError') {
            logger.error('Error getting dexie entries, open failed error.');
            resolve(null);
          } else {
            logger.error('Error getting dexie entries: ' + error.message);
            reject(error);
          }
      });     
    });
  }


  public removeItem(key) {
    key = this.urlBasePathService.getBasePath() + key;
    const self = this;
  
    return new Promise<any>((resolve, reject) => {
      super.removeItem(key).then(deleteCount =>{
        resolve(deleteCount);
      }, error => {
        if (error.name === 'OpenFailedError') {
          resolve(1);
        } else {
          logger.error('Error removing dexie entries: ' + error.message);
          reject(error);
        }
      });
    });
  }



}
